// extracted by mini-css-extract-plugin
export default {"wrapper":"LeadGenForm_wrapper__mjLSq"};